import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ActivityIndicator } from "react-native";
export const LoadingSpinner = React.memo(function LoadingSpinner() {
    return (_jsx(ActivityIndicator, { size: "small", color: "white" }));
});
